import * as React from "react";
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Button, ModalFooter } from "reactstrap";
import i18n from "../i18n";
import { Content } from "models/content";

export interface ContentEditProps {
    isOpen: boolean;
    content: Content;
    onCancel: () => void;
    onSave: (content: Content) => void;
}
export interface ContentEditState {
    content: Content
}

export default class ContentEdit extends React.Component<
    ContentEditProps,
    ContentEditState
    > {

    constructor(props: ContentEditProps) {
        super(props)
        this.state = {
            content: props.content
        }
    }

    componentWillReceiveProps(nextProps: ContentEditProps) {
        this.setState({
            content: nextProps.content
        });
    }

    render() {
        const { isOpen, onCancel, onSave } = this.props;
        return (
            <Modal isOpen={isOpen} className="scenario-edit">
                <ModalHeader>
                    {i18n.Contents.Form.EditTitle}
                </ModalHeader>
                <ModalBody>
                    {this.model && (
                        <Form>
                            <FormGroup>
                                <Label>{i18n.Contents.Table.Type}</Label>
                                <br />
                                {this.model.type}
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Contents.Table.Description}</Label>
                                <br />
                                {this.model.description}
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Contents.Table.Message}</Label>
                                <br />
                                <textarea
                                    rows={5}
                                    cols={60}
                                    name="message"
                                    value={this.model.message}
                                    onChange={this.updateField}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>{i18n.Contents.Table.Speak}</Label>
                                <br />
                                <textarea
                                    rows={5}
                                    cols={60}
                                    name="speak"
                                    value={this.model.speak}
                                    onChange={this.updateField}
                                />
                            </FormGroup>
                        </Form>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        onClick={() => onSave(this.state.content)}
                    >
                        {i18n.Global.Edit.Confirm}
                    </Button>
                    <Button
                        color="default"
                        onClick={() => onCancel()}
                    >
                        {i18n.Global.Edit.Cancel}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    private get model() {
        return this.state.content;
    }

    private updateField = (event: { target: any; }) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        switch (name) {
            case "message":
                this.setState(prevState => ({ content: { ...prevState.content, message: value } }));
                break;
            case "speak":
                this.setState(prevState => ({ content: { ...prevState.content, speak: value } }));
                break;
            default:
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/contents/content-edit.tsx